module.exports = __webpack_public_path__ + "static/media/processing.a0fae63e.png";